import styled from '@emotion/styled';
import { bindActionCreators } from '@reduxjs/toolkit';
import { space } from 'folio-common-components';
import * as React from 'react';
import { connect } from 'react-redux';
import { Labels } from '../../messages';
import type { Dispatch } from '../../state';
import {
  type Person,
  thunks as editThunks,
  newPerson,
} from '../../state/editor';
import { isValidPnum } from '../../utils/validators';
import { PersonInput } from '../PersonInput';
import { Box, BoxHeading } from '../box';
// TODO: this should be made generic to be used by different components
import { Button, TextButton } from '../buttons';

interface Props {
  onDone: () => any;
  onCreatePerson: (p: Person) => any;
  currentCeo?: Person;
  editType: 'edit' | 'new';
}

interface State {
  person: Person;
  hasClickedSave: boolean;
}

const SaveButton = styled(Button)`
  margin-right: 24px;
`;

class BaseCeoPersonForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      person:
        props.editType === 'edit' && props.currentCeo
          ? props.currentCeo
          : newPerson(),
      hasClickedSave: false,
    };
  }

  onFormChange = (person: Person) => {
    this.setState({ person });
  };

  render() {
    const { person, hasClickedSave } = this.state;
    const { onCreatePerson, onDone, editType } = this.props;
    return (
      <>
        <BoxHeading>Ny daglig leder</BoxHeading>
        <Box>
          <form
            noValidate={true}
            onSubmit={evt => {
              evt.preventDefault();
            }}
            data-testid="CeoPersonForm"
          >
            <PersonInput
              inputs={['autoName', 'pNum', 'phone', 'email']}
              person={person}
              onChange={this.onFormChange}
              disableAutocomplete={true}
              validate={hasClickedSave}
              editType={editType}
            />
            <div css={space([48], 'margin-top')}>
              <SaveButton
                onClick={() => {
                  this.setState({ hasClickedSave: true });
                  if (!isValidPnum(person.pNum)) {
                    return;
                  }

                  onCreatePerson(person);
                  onDone();
                }}
              >
                <Labels.Done />
              </SaveButton>{' '}
              <TextButton onClick={onDone}>
                <Labels.Cancel />
              </TextButton>
            </div>
          </form>
        </Box>
      </>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      onCreatePerson: editThunks.addPersonCeo,
    },
    dispatch,
  );
}

export const CeoPersonForm = connect(
  null,
  mapDispatchToProps,
)(BaseCeoPersonForm);
